import { ApeironTitle } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import RewardSecNavBar from '@src/components/navigationBar/secondary/RewardSecNavBar'
import CheckInBanners from '@src/components/reward/checkIn/CheckInBanners'
import CheckInDays from '@src/components/reward/checkIn/CheckInDays'
import CheckInGiftShop from '@src/components/reward/checkIn/CheckInGiftShop'
import CheckInStardust from '@src/components/reward/checkIn/CheckInStardust'
import { DailyCheckInProvider } from '@src/contexts/reward/DailyCheckInContext'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import { t } from 'i18next'
import { NextPage } from 'next'
import { useEffect } from 'react'

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1024px;
  ${props => props.theme.breakpoints.up('res1024')} {
    width: 1000px;
    gap: 20px;
    margin: 40px auto;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    gap: 20px;
    padding: 15px 15px;
  }
`

const TitleContainer = styled(Box)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

const DailyCheckInPage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  useEffect(() => {
    setupBar(<RewardSecNavBar index={2} />)

    return () => setupBar(null)
  }, [setupBar])

  return (
    <DailyCheckInProvider>
      <Container>
        <TitleContainer>
          <ApeironTitle text={t('adeptus.reward.checkin.title')} />
          <CheckInStardust />
        </TitleContainer>
        <CheckInBanners />
        <CheckInDays />
        <CheckInGiftShop />
      </Container>
    </DailyCheckInProvider>
  )
}

type Props = {}

export default DailyCheckInPage
